@if (isSelfAuthoring()) {
  <app-accordion-card
    [title]="'simulationBuilder.METHODOLOGY_TITLE' | transloco"
    [subHeading]="'simulationBuilder.METHODOLOGY_SUBTITLE' | transloco"
    [expanded]="true"
  >
    <qai-badge
      controls
      [shape]="'rectangle'"
      [kind]="'default'"
      [size]="'xsmall'"
      [label]="'simulationBuilder.METHODOLOGY_WEIGHTING_LABEL' | transloco: { weight: methodologyWeight() }"
    ></qai-badge>
    <div class="rubric-row">
      <div class="rubric-field">
        <qai-field [label]="'simulationBuilder.METHODOLOGY_RUBRIC_LABEL' | transloco">
          <qai-floating-select
            [shape]="'rectangle'"
            [placeholder]="'simulationBuilder.SELECT_RUBRIC_PLACEHOLDER' | transloco"
            [options]="rubricOptions"
            [allowDeselect]="true"
            [disabled]="readOnly"
            [value]="methodologyPromptGroup?.get('rubric')?.value ?? ''"
            (valueChange)="onRubricChange($event)"
          ></qai-floating-select>
        </qai-field>
      </div>
      @if (selectedMethodology()) {
        <div class="description-card">
          <p class="description-card__name">{{ selectedMethodology()!.name }}</p>
          <p class="description-card__text">{{ selectedMethodology()!.description }}</p>
        </div>
      }
    </div>
  </app-accordion-card>
} @else {
  <details-section [title]="'simulationBuilder.METHODOLOGY_TITLE' | transloco" [showDetails]="false">
    <div class="container" [formGroup]="form">
      <div [formGroup]="methodologyPromptGroup">
        <qai-field [label]="methodologyPromptLabel">
          <textarea
            qai-textarea
            autosize
            [maxLines]="30"
            qaiTrimLeading
            qaiPasteClean
            formControlName="promptText"
          ></textarea>
        </qai-field>
      </div>
    </div>
  </details-section>
}
